import React from "react";
import Select from "react-select";
import { FormControl, FormLabel, Stack, TextField } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { COMPANY_STATUS_LIST } from "../../helpers/constant/coreConstant";
import PageTitle from "../../common/PageTitle";

const JobSeekerHeader = () => {
  const AllOptionObj = { "": { value: "", label: "All" } };
  const companyStatusOptions = { ...AllOptionObj, ...COMPANY_STATUS_LIST };
  return (
    <>
      <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "flex-start", md: "center" }} justifyContent={"space-between"} spacing={2} mb={3}>
        <PageTitle title={"Job Seeker"} mb={0} subTitleMb={0} />
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "stretch", sm: "flex-end" }} sx={{ width: { xs: "100%", md: "auto" } }}>
          <FormControl sx={{ flexGrow: 1, minWidth: { xs: "100%", sm: 200 }, maxWidth: { md: 330 } }}>
            <FormLabel>Search By Job Seeker Email:</FormLabel>
            <TextField
              size={"small"}
              type={"search"}
              placeholder={"Search By Job Seeker Email"}
              InputProps={{
                startAdornment: <SearchRoundedIcon fontSize={"small"} color={"action"} sx={{ ml: 1 }} />,
              }}
            />
          </FormControl>
          <FormControl sx={{ flexGrow: 1, minWidth: { xs: "100%", sm: 200 }, maxWidth: { md: 300 } }}>
            <FormLabel>Filter By Job Seeker Status:</FormLabel>
            <Select
              className={"select-dropdown-menu select-dropdown-menu-custom"}
              classNamePrefix={"select-dropdown-styles"}
              isMulti={false}
              isSearchable={false}
              menuPlacement="bottom"
              options={Object.values(companyStatusOptions)}
            />
          </FormControl>
        </Stack>
      </Stack>
    </>
  );
};

export default JobSeekerHeader;
